// @view/panels/invite/InviteAcceptBody.panel.tsx
import React from "react";
import type { InviteAcceptBodyPhase } from "@ps-bridge/models/ui/inviteAcceptBodyPhase";
import type { InviteAcceptViewProps } from "@ps-bridge/contracts/inviteAccept";
import InviteAcceptBodyReadyView from "@view/invite/InviteAcceptBodyReady.view";
import InviteAcceptBodyMissingTokenView from "@view/invite/InviteAcceptBodyMissingToken.view";

type InviteAcceptBodyPanelProps = Pick<
  InviteAcceptViewProps,
  | "bodyPhase"
  | "password"
  | "confirmPassword"
  | "firstName"
  | "lastName"
  | "onPasswordChange"
  | "onConfirmPasswordChange"
  | "onFirstNameChange"
  | "onLastNameChange"
  | "onSubmit"
>;

const InviteAcceptBodyPanel: React.FC<InviteAcceptBodyPanelProps> = (props) => {
  const { bodyPhase, ...viewProps } = props;
  const phaseKeys = {
    ready: "ready",
    missingToken: "missingToken",
  } as const satisfies Record<InviteAcceptBodyPhase, InviteAcceptBodyPhase>;

  const render = {
    [phaseKeys.ready]: <InviteAcceptBodyReadyView {...viewProps} />,
    [phaseKeys.missingToken]: <InviteAcceptBodyMissingTokenView {...viewProps} />,
  } as const satisfies Record<InviteAcceptBodyPhase, React.ReactElement>;

  return render[bodyPhase as keyof typeof render];
};

export default InviteAcceptBodyPanel;
